import { make } from 'vuex-pathify'

const state = {
  matchedRoutes: []
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  ...make.mutations(state)
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
